module.exports = __webpack_public_path__ + "img/32.47f20ba8.png";